import { useLocation } from 'react-router';

function PageInfo() {
  let location = useLocation();
  return location;
}

export default PageInfo;
